<template>
  <div class="is-second navigator-highlight">
    <div class="section-heading" v-if="title" v-html="title"></div>
    <div class="columns is-multiline">
      <div v-show="chemistryList.length" class="column is-12-tablet" :class="classList">
        <div class="content">
          <ul
            class="navigator-highlight__list buttons-list"
            :class="classListChemistry"
            ref="chemistry"
          >
            <slot></slot>
          </ul>
        </div>
      </div>
      <div v-show="productsList.length" class="column is-12-tablet" :class="classList">
        <ul class="has-text-info list-products" ref="product"></ul>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationProductFullWidth from "./NavigationProductFullWidth.vue";

export default {
  name: "NavigationHighLight",
  components: {
    NavigationProductFullWidth,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    columns: {
      type: Number,
      default: 1,
    },
    isSecond: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chemistryList: [],
      productsList: [],
    };
  },
  mounted() {
    const $chemistry = this.$el.querySelectorAll(".chemistry");
    if ($chemistry.length) {
      this.chemistryList = $chemistry;
    }

    const $product = this.$el.querySelectorAll(".product");

    if ($product.length) {
      $product.forEach((item) => {
        this.$refs["product"].insertBefore(item, null);
      });
      this.productsList = $product;
    }
  },
  computed: {
    classList() {
      if (this.chemistryList.length) {
        return this.columns == 1
          ? "is-7-desktop"
          : "is-6-widescreen is-12-desktop";
      } else {
        return "is-12";
      }
    },
    classListChemistry() {
      switch (this.columns) {
        case 1:
          return "one-column-desktop is-small";
        case 2:
          return "three-columns-desktop";
        case 3:
          return "four-columns-desktop";
        default:
          return "two-columns-desktop";
      }
    },
  },
};
</script>
